import { Button, Tooltip, Modal, Form, Select } from 'antd';
import React from 'react';
import { api, use } from 'xadmin';
import { Icon } from 'xadmin-ui';
import { saveAs } from 'file-saver';
import XLSX from 'xlsx';
const { Option } = Select;

const TIPS = '保证导入的数据文字和系统中是一致的，如部门编号，带“*”的字段为必填项，请填写完整再上传，否则上传失败'
/* see Browser download file example in docs */
function s2ab(s/*:string*/)/*:ArrayBuffer*/ {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
  return buf
}
// 根据model动态生成上传参数
const findColumns = (schema, prefix, columns) => {
  const properties = schema.items && schema.items.properties || {}
  let keys = schema?.form ? (
    schema.form.indexOf('*') >= 0 ?
      Object.keys(properties) : schema.form?.map(f => typeof f == 'string' ? f : f.key)) :
    Object.keys(properties)

  keys = [...keys,
  ...Object.keys(properties)
    .filter(k => keys.indexOf(k) == -1 && properties[k].type == 'object')]
    .filter(k => k != 'model')

  keys.forEach(key => {
    const p = properties[key]
    if (p?.export === false) return
    const ifRequire = schema?.items?.required?.indexOf(key) > -1 ? '*' : ''
    if (!p) return
    if (p.type == 'object') {
      if (p.fieldType != undefined) {
        columns.push({
          title: prefix.title + p.title,
          name: prefix.name + (p.name || key),
          description: p?.description || '',
          type: p.type
        })
      } else if (p.relateTo == undefined) {
        findColumns(p, { title: p.title + '-', name: prefix.name + key + '.', description: p?.description || '', }, columns)
      }
    } else if (p.type == 'array') {
      if (p.fieldType != undefined) {
        columns.push({
          title: prefix.title + p.title + '编号',
          name: prefix.name + (p.name || key),
          description: p?.description || '',
          type: p.type, fieldType: p.fieldType
        })
      }
    } else {
      let description = p?.description || ''
      // 数据点标识 description 
      if (p?.title === '标识' && !p?.description) {
        description = '标识唯一，包含汉字、字母、数字、特殊字符$-_:（修改标识后会导致无法查询以旧标识存储的历史数据）'
      }
      columns.push({
        title: prefix.title + p.title,
        name: prefix.name + (p.name || key),
        description,
        type: p.type
      })
    }
  });
  return columns
}

const DownloadButtion = ({ field }) => {
  const onDownload = () => {
    const columns = findColumns(field.schema, { title: '', name: '' }, [])

    const ws = XLSX.utils.aoa_to_sheet([
      columns.map(col => {
        return col.description ? { v: col.title, t: 's', c: [{ t: col.description, }] } : { v: col.title, t: 's' }
      })
    ])
    // 根据配置的宽度生成表格宽度
    ws['!cols'] = columns.map(col => ({ wpx: col.width ? col.width : Math.max(45, col.title.length * 15) }))
    Object.values(ws).forEach(item => {
      if (_.isObject(item) && item?.c) {
        item.c['hidden'] = true
      }
    })

    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws)

    /* generate XLSX file */
    const wbout = XLSX.write(wb, { type: 'binary', bookType: 'xlsx' })
    /* send to client */
    saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), `${field.label}_导入模板.xlsx`)
  }

  return <Button onClick={onDownload} >下载模板</Button>
}

const UploadComponent = props => {
  const { field, uploader, selectRule, setSelectRule } = props
  let canAdd = false
  const [visible, setVisible] = React.useState(false)
  const title = '导入' + field.label ?? ''
  try {
    if (!use('model')?.model) canAdd = true
    canAdd = use('model.permission')['canAdd']
  } catch (error) {
  }

  const onChange = (value) => {
    setSelectRule(value)
  }

  return canAdd && (
    <span>
      <Tooltip title="导入">
        <Button onClick={() => { setVisible(true) }}><Icon name="import" /></Button>
      </Tooltip>
      <Modal
        title={title}
        destroyOnClose
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={() => { }}
      >
        <Form.Item label="数据模板" extra="请根据模板填写数据"><DownloadButtion field={field} /></Form.Item>
        <Form.Item label="处理规则">
          <Select value={selectRule} defaultValue={'false'} style={{ width: 140 }} onChange={onChange}>
            <Option value="false">报错提示并跳过</Option>
            <Option value="true">覆盖更新</Option>
          </Select>
        </Form.Item>
        <Form.Item label="上传文件">
          <Button onClick={() => { uploader.click() }} >
            <Icon type="upload" /> 上传
          </Button>
        </Form.Item>
      </Modal>
    </span>
  )
}

export default UploadComponent
